// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__189F5","header":"PatientQuestionnaire_header__2_wfK","info":"PatientQuestionnaire_info__CzQZY"};